import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBreakpoint } from '@common/application/hooks/use-breakpoint';
import { Fragment } from 'react';
import { LanguageChange } from './language-change';
import { ServiceCenter } from './service-center';
import { User } from './user';
const WebLanguageHeader = ({ showUser = true }) => {
    return (_jsx("div", Object.assign({ className: "h-11 w-full bg-black-6" }, { children: _jsx("div", Object.assign({ className: "container mx-auto h-full flex justify-end" }, { children: _jsxs("div", Object.assign({ className: "h-full flex items-center justify-center text-black-2 text-sm leading-none" }, { children: [showUser && _jsx(User, {}), _jsx(ServiceCenter, {}), _jsx(LanguageChange, {})] })) })) })));
};
export const LanguageHeader = ({ showUser = true, show = false }) => {
    const screens = useBreakpoint();
    if (!show)
        return _jsx(Fragment, {});
    return screens.pc ? _jsx(WebLanguageHeader, { showUser: showUser }) : _jsx(Fragment, {});
};
